import React, { useEffect, useState } from "react";
import firebase from "./firebase";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";
import ForgotPassword from "./ForgotPassword";
import url from "../../constants/URL";

export default function FirebasePhoneAuth(props) {
  const [verified, setVerified] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  useEffect(() => {
    const uiConfig = {
      signInOptions: [
        {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          recaptchaParameters: {
            type: "image",
            size: "normal",
            badge: "bottomleft",
          },
          defaultCountry: "PK",
        },
      ],
      callbacks: {
        signInSuccessWithAuthResult: function (authResult, redirectUrl) {
          setPhoneNumber(authResult.user.phoneNumber);
          checkPhoneNumber(authResult.user.phoneNumber);
          return true;
        },
      },
    };
    var ui = new firebaseui.auth.AuthUI(firebase.auth());
    ui.start("#firebase-auth-container", uiConfig);
  }, []);

  const checkPhoneNumber = () => {
    fetch(`${url}/check/+92${phoneNumber}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response) => {
        if (response === true) {
          setVerified(true);
        } else {
          showErrorAlert();
        }
      });
  };

  const showErrorAlert = () => {
    window.confirm("This Number is not attached with any account")
      ? props.history.push(`/`)
      : props.history.push(`/forgot/password`);
  };

  return (
    <>
      {verified ? (
        <ForgotPassword phoneNumber={phoneNumber} {...props} />
      ) : (
        <div style={{ marginTop: "15%" }}>
          <div id="firebase-auth-container"></div>
        </div>
      )}
    </>
  );
}
